// Which confirmation mail an activation sends.
//
// A CLOSED LIST OF NAMED TEMPLATES, NOT PASTED HTML. The body of an OTP
// message is a live credential, and the HTML that carries it is table-based
// mail: light and dark in one document, image-off fallbacks, an iOS-autofill
// plaintext part. An operator textarea would be a XSS surface, a phishing-shaped
// mail, and a template that silently breaks in Outlook the first time somebody
// pastes a <div>. The console offers these names. The send path is what
// interpolates the code.
//
// RIDE TO SURVIVE IS PINNED HERE rather than stored on the activation row.
// Email goes out at request-code time, before any published bundle is read, so
// a field on the bundle would not reach this file. A saved choice per show is
// the next step; until that column exists, the activation ids below are the
// only ones that select anything other than the default confirmation.

export const OTP_EMAIL_TEMPLATES = ["default", "ride_to_survive"] as const;

export type OtpEmailTemplate = (typeof OTP_EMAIL_TEMPLATES)[number];

/** Staging Ride to Survive. FortNine/app/.env `VITE_XP_ACTIVATION_ID`. */
export const RIDE_TO_SURVIVE_ACTIVATION_ID = "83411246-2990-4479-a444-fe233dfb7699";

/** Production Ride to Survive, opened 2026-09-12. */
export const RIDE_TO_SURVIVE_PRODUCTION_ACTIVATION_ID = "b4aa7c8d-107d-49da-b9b1-c9010720e387";

export function isRideToSurviveActivation(activationId: string | null | undefined): boolean {
  return (
    activationId === RIDE_TO_SURVIVE_ACTIVATION_ID ||
    activationId === RIDE_TO_SURVIVE_PRODUCTION_ACTIVATION_ID
  );
}

export function otpEmailTemplateFor(activationId: string | null | undefined): OtpEmailTemplate {
  return isRideToSurviveActivation(activationId) ? "ride_to_survive" : "default";
}
